import { useChatSocket } from "../hooks/useChatSocket";

/** Keeps papaya_chat websocket alive while the dashboard shell is mounted. */
export function ChatSocketBootstrap() {
  useChatSocket(true);
  return null;
}
